import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum'
import { ENV } from './common/core/domain/env';

@Injectable({
  providedIn: 'root'
})
export class DataDogService {

  init(env: string, connectUserId: string, businessUnit: string) {
    if (/*env === ENV.localhost ||*/ env === ENV.stag || env === ENV.prod) {
      datadogRum.init({
        applicationId: 'f3f4df53-1a61-4f4a-8f8e-749f80b67a2d',
        clientToken: 'pubdff36bb309c023390415cb33193593db',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.eu',
        service: 'admin-user-access',
        env: env,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        // sessionReplaySampleRate: 20,
        // defaultPrivacyLevel: 'mask',
      });

      datadogRum.setUser({
        id: connectUserId,
        businessUnit: businessUnit
      });
    }
  }
}
